module.exports = __webpack_public_path__ + "img/icon-livingroom.b9d081af.svg";